import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {Theme} from '@emotion/react';

import {ReactComponent as ArticlesSVG} from '../../assets/icons/ic_library.svg';
import {ReactComponent as ProfileSVG} from '../../assets/icons/ic_profile.svg';
import {ReactComponent as ContactSVG} from '../../assets/icons/ic_help.svg';
import {ReactComponent as SubscriptionSVG} from '../../assets/icons/ic_subscription.svg';
import {ReactComponent as LoanSVG} from '../../assets/icons/ic_loan.svg';

export const QuickLinksWrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${({theme}) => theme.gap.desktop.xl};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    gap: ${({theme}) => theme.gap.mobile.sm};
  }
`;

const styledQuickLinksIcon = ({theme}: {theme: Theme}) => css`
  width: ${theme.icon.size.lg};
  height: ${theme.icon.size.lg};
  color: ${theme.color.primary_70};
`;

export const IconArticles = styled(ArticlesSVG)(styledQuickLinksIcon);
export const IconProfile = styled(ProfileSVG)(styledQuickLinksIcon);
export const IconContact = styled(ContactSVG)(styledQuickLinksIcon);

const styledIcon = ({theme}: {theme: Theme}) => css`
  width: ${theme.icon.size.lg};
  height: ${theme.icon.size.lg};
  color: ${theme.color.neutral.grey_900};
`;

export const IconSubscription = styled(SubscriptionSVG)(styledIcon);
export const IconLoan = styled(LoanSVG)(styledIcon);
